import React from 'react';
import { Container, Row } from 'react-bootstrap';

import './ClFooter.scss';

const ClFooter = () => {
  return (
    <Container fluid className="cl-footer">
      <Row className="cl-footer-container">
        <a
          href="https://github.com/nhanlnt-96/jay-portfolio"
          target="_blank"
          className="content"
          rel="noreferrer"
        >
          Built by Le Nguyen Thien Nhan
        </a>
      </Row>
    </Container>
  );
};

export default ClFooter;
